module.exports = __webpack_public_path__ + "static/media/uaeiaa_logo.2e49cf96.a5bced40.svg";